import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import FoodAddEditComponent from "../component/restaurants/foods/FoodAddEditComponent";
import useUserStore from "../stores/store";
import { getCategoryDropdownList } from "../services/food-service";
import CustomLoader from "../component/menu/CustomLoader";

function FoodEdit() {
  const { user, restaurantId, setNetworkCall } = useUserStore();
  const [isCategoryListFetched, setIsCateogryListFetched] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryDropdownList, setCategoryDropdownList] = useState([]);

  const fetchCategoryList = async (restaurantId, token) => {
    setNetworkCall(true);
    setIsCateogryListFetched(false);
    const result = await getCategoryDropdownList(restaurantId, token);
    setCategoryList(result.categoryList);
    setCategoryDropdownList(result.categoryDropdownList);
    setIsCateogryListFetched(true);
    setNetworkCall(false);
  };

  useEffect(() => {
    if (restaurantId && user?.token) {
      fetchCategoryList(restaurantId, user.token.token);
    }
  }, [user, restaurantId]);

  return (
    <div className="flex flex-col mx-[12%]">
      <CustomLoader />
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} currentMenuKey={'T_3_S_3'}/>
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div>
              <FormHeaderComponent title={`Edit Food`} listRoute="/food" />
            </div>
            <div>
              {isCategoryListFetched && (
              <FoodAddEditComponent
                categoryList={categoryList}
                categoryDropdownList={categoryDropdownList}
              />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FoodEdit;
